import ModalViewModel from 'infra/ModalViewModel'
import Job from 'jobs/Job'
import JobProgressionStore from 'jobs/progression/JobProgressionStore'
import { action, computed, makeObservable } from 'mobx'
import { task } from 'mobx-task'

export class StartProgressionDialogViewModel extends ModalViewModel {
  constructor(
    private progressionStore: JobProgressionStore,
    private job: Job,
  ) {
    super()
    makeObservable(this)
  }

  @computed
  get progressionFlow() {
    return this.progressionStore.progressionForJob(this.job.id)?.progressionFlow
  }

  @action.bound
  startJobProgression = task.resolved(async () => {
    await this.progressionStore.setJobStartedProgression(this.job.id)
    this.close()
  })
}
